export enum InvestorValidationLabels {
  OnlySpecialSymbolsNotAllowed = 'Only special symbols are not allowed.',
  EmailInvalid = 'Email is invalid',
  IndividualAccountNotUnique = 'An investor with the same date of birth and a similar name has been found. Please check this is not a duplicate.',
  LegalEntityAccountNotUnique = 'An investor with the same registered name has been found. Please check this is not a duplicate.',
  UserNotDeceased = 'Investor not deceased',
}
